import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './stepss.css';
import { useTranslation } from 'react-i18next';

const Stepss = (props) => {
  const { t } = useTranslation();
  return (
    <div className='stepss-container1 thq-section-padding'>
      <div className='stepss-max-width thq-section-max-width'>
        <div className='stepss-container2 thq-grid-2'>
          <div className='stepss-section-header'>
            <h2 className='thq-heading-2'>⚡{t('stepss.title')}</h2>
            <p className='thq-body-large'>
              <span>{t('stepss.subtitle')}</span>
              <br></br>
            </p>
            <div className='stepss-actions'>
              <button className='thq-button-animated thq-button-filled stepss-button'>
                <a
                  href='https://t.me/schengen_visa_slot_bot?start=we_04_0000'
                  target='_blank'
                  rel='noreferrer noopener'
                  className='stepss-text14 thq-body-small'
                >
                  {t('stepss.signUp')}
                </a>
              </button>
            </div>
          </div>
          <div className='stepss-container3'>
            <div className='stepss-container4 thq-card'>
              <h2 className='thq-heading-2'>
                {props.step1Title ?? (
                  <Fragment>
                    <span className='stepss-text27'>{t('stepss.step1Title')}</span>
                  </Fragment>
                )}
              </h2>
              <span className='stepss-text16 thq-body-small'>
                {props.step1Description ?? (
                  <Fragment>
                    <span className='stepss-text24'>{t('stepss.step1Description')}</span>
                  </Fragment>
                )}
              </span>
              <label className='stepss-label1 thq-heading-3'>01</label>
            </div>
            <div className='stepss-container5 thq-card'>
              <h2 className='thq-heading-2'>
                {props.step2Title ?? (
                  <Fragment>
                    <span className='stepss-text23'>{t('stepss.step2Title')}</span>
                  </Fragment>
                )}
              </h2>
              <span className='stepss-text18 thq-body-small'>
                {props.step2Description ?? (
                  <Fragment>
                    <span className='stepss-text25'>{t('stepss.step2Description')}</span>
                  </Fragment>
                )}
              </span>
              <label className='stepss-text19 thq-heading-3'>02</label>
            </div>
            <div className='stepss-container6 thq-card'>
              <label className='stepss-label2 thq-heading-3'>03</label>
              <h2 className='thq-heading-2'>
                {props.step3Title ?? (
                  <Fragment>
                    <span className='stepss-text26'>{t('stepss.step3Title')}</span>
                  </Fragment>
                )}
              </h2>
              <span className='stepss-text21 thq-body-small'>
                {props.step3Description ?? (
                  <Fragment>
                    <span className='stepss-text22'>{t('stepss.step3Description')}</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Stepss.defaultProps = {
  step3Description: undefined,
  step2Title: undefined,
  step1Description: undefined,
  step2Description: undefined,
  step3Title: undefined,
  step1Title: undefined,
};

Stepss.propTypes = {
  step3Description: PropTypes.element,
  step2Title: PropTypes.element,
  step1Description: PropTypes.element,
  step2Description: PropTypes.element,
  step3Title: PropTypes.element,
  step1Title: PropTypes.element,
};

export default Stepss;
